import { DataTypeConfig } from "@features/onboarding/data-migration/types";

export const consumersConfig: DataTypeConfig = {
  tabs: ["plan", "category", "subCategory", "status"],
  searchableColumns: [
    "consumer_no",
    "first_name",
    "last_name",
    "email",
    "contact_number",
    "street",
    "Plan",
    "Category",
    "Sub Category",
    "Status",
  ],
  filterColumns: [
    { column: "ownership", type: "dropdown", label: "Ownership" },
    { column: "billing_premise", type: "dropdown", label: "Billing Premise" },
    { column: "Plan", type: "dropdown", label: "Plan" },
    { column: "Category", type: "dropdown", label: "Category" },
    { column: "Sub Category", type: "dropdown", label: "Sub Category" },
    { column: "Status", type: "dropdown", label: "Status" },
    { column: "connect_date", type: "date", label: "Connect Date" },
    { column: "zipcode", type: "multi-select", label: "Zipcode" }, // ✅ CHANGED from "select" to "multi-select"
  ],
  tableColumns: [
    { key: "consumer_no", header: "Consumer No", type: "custom" },
    { key: "first_name", header: "First Name", type: "custom" },
    { key: "last_name", header: "Last Name", type: "custom" },
    { key: "email", header: "Email", type: "custom" },
    { key: "contact_number", header: "Contact Number", type: "custom" },
    { key: "street", header: "Street", type: "custom" },
    { key: "plan", header: "Plan", type: "badge" },
    { key: "category", header: "Category", type: "badge" },
    { key: "subCategory", header: "Sub Category", type: "badge" },
    { key: "status", header: "Status", type: "badge" },
    {
      key: "alternate_contact_number",
      header: "Alternate Contact",
      type: "custom",
    },
    { key: "address_line", header: "Address Line", type: "custom" },
    { key: "remarks", header: "Remarks", type: "custom" },
    { key: "ownership", header: "Ownership", type: "badge" },
    { key: "connect_date", header: "Connect Date", type: "custom" },
    { key: "opening_balance", header: "Opening Balance", type: "custom" },
    { key: "billing_premise", header: "Billing Premise", type: "badge" },
    { key: "service_premise", header: "Service Premise", type: "custom" },
    { key: "unit", header: "Unit", type: "custom" },
    { key: "zipcode", header: "Zipcode", type: "custom" },
  ],
  mandatoryFields: [
    "consumer_no",
    "first_name",
    "last_name",
    "email",
    "contact_number",
    "street",
    "ownership",
    "connect_date",
    "billing_premise",
    "zipcode",
    "Plan",
    "Category",
    "Status",
  ],
};

export const consumersTabDisplayNames: Record<string, string> = {
  plan: "Plan",
  category: "Category",
  subCategory: "Sub Category",
  status: "Status",
};

export const consumersTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "plan":
      return [
        { value: "standard", label: "Standard Plan" },
        { value: "premium", label: "Premium Plan" },
        { value: "basic", label: "Basic Plan" },
        { value: "enterprise", label: "Enterprise Plan" },
      ];
    case "category":
      return [
        { value: "residential", label: "Residential" },
        { value: "commercial", label: "Commercial" },
        { value: "industrial", label: "Industrial" },
      ];
    case "sub_category":
      return [
        { value: "single_family", label: "Single Family" },
        { value: "multi_family", label: "Multi Family" },
        { value: "retail", label: "Retail" },
        { value: "office", label: "Office" },
      ];
    case "status":
      return [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
        { value: "suspended", label: "Suspended" },
      ];
    default:
      return [];
  }
};
